"use client";

import React, { type JSX } from "react";
import { useAuth, useUser } from "@clerk/nextjs";

import { Show } from "@clerk/nextjs";

import Link from "next/link";
import { PiBuildingOfficeLight, PiUserLight } from "react-icons/pi";
import classNames from "classnames";
import { useSignInRedirect } from "@/auth/hooks/useSignInRedirect";

export default function MyPageButton({
  className,
  style,
  showIcon = true,
  showText = true,
}: Pick<JSX.IntrinsicElements["button"], "className" | "style"> & {
  showIcon?: boolean;
  showText?: boolean;
}) {
  const { isLoaded } = useUser();
  const { orgId } = useAuth();
  const signInAction = useSignInRedirect();

  if (!isLoaded) {
    return <span className="max-h-7 text-sm font-light">Laster...</span>;
  }

  return (
    <>
      <Show when="signed-out">
        <button
          onClick={signInAction}
          className={classNames(
            "cursor-pointer grid-cols-[auto_1fr] items-center gap-1",
            className,
          )}
          style={style}
          {...(!showText && { "aria-label": "Logg inn" })}
        >
          {showIcon ? <PiUserLight className="inline" size={28} /> : null}
          {showText ? (
            <span className="text-sm font-light">Logg inn</span>
          ) : null}
        </button>
      </Show>
      <Show when="signed-in">
        <Link href="/min-side">
          <button
            className={classNames(
              "cursor-pointer grid-cols-[auto_1fr] items-center gap-1",
              className,
            )}
            style={style}
            {...(!showText && { "aria-label": "Min side" })}
          >
            {showIcon ? (
              orgId ? (
                <PiBuildingOfficeLight className="inline" size={28} />
              ) : (
                <PiUserLight className="inline" size={28} />
              )
            ) : null}
            {showText ? (
              <span className="text-sm font-light">Min side</span>
            ) : null}
          </button>
        </Link>
      </Show>
    </>
  );
}
